import { ClienteClase } from "./ClienteClase.model";
import { CondicionesPago } from "./CondicionesPago.model";
import { ClienteContacto } from "./ClienteContacto.model";
import { ClienteEspecificaciones } from "./ClienteEspecificaciones.model";
import { ClienteDirecciones } from "./ClienteDirecciones.model";
import { ClienteBancos } from "./ClienteBancos.model";

export class Proveedor {
    //proveedor
    //ASDASDASD
    id_cia: number = 0;

    tident: string;
    tidentNombre: string;
    codcli: string;
    razonc: string;
    dident: string;
    direc1: string;
    direc2: string;
    email: string;
    fax: string;
    telefono: string;
    repres: string;
    codtit: number = 0;
    codtitcom: number = 0;
    codtpe: number = 0;
    codpag: number = 0;
    //codsec: number = 0;
    descodpag: string;
    codven: number = 0;
    desven: string;
    regret: number = 0;
    tiporegret: string;
    limiteCredito: number = 0;
    //observ: string;
    exoimp: string;
    tipopersona: string;
    apellidopaterno: string;
    apeliidomaterno: string;
    nombres: string;
    sexo: string;
    fnacimiento: string;
    nrodni: string;
    activo: boolean;
    //fecing: string;
    //valident: boolean;

    credito: string;

    clase_01: string;
    clase_22: string;
    clase_30: string;
    clase_32: string;

    // Provision de compras
    situacion: string;
    relacion: string;

    nombrescompletos: string;
    nombresayuda: string;
    titulolista: string;

    public clases: ClienteClase[];
    public condicionespago: CondicionesPago[];
    public contactos: ClienteContacto[];
    public especificaciones: ClienteEspecificaciones[];
    public direccionesenvio: ClienteDirecciones[];
    public bancos: ClienteBancos[];

}